import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // Could log to a service here
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          minHeight: "100vh",
          background: "var(--s1, #0a0a0f)",
          color: "var(--t1, #fff)",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          fontFamily: "var(--font-sans, system-ui)",
          padding: "2rem",
          textAlign: "center"
        }}>
          <h1 style={{ fontSize: "2rem", marginBottom: "1rem", color: "var(--p, #a78bfa)" }}>
            Something went wrong
          </h1>
          <p style={{ color: "var(--t2, #999)", marginBottom: "2rem", maxWidth: 500 }}>
            Dream Machine hit an unexpected error. Try refreshing the page.
          </p>
          <button
            onClick={() => window.location.reload()}
            style={{
              background: "var(--p, #a78bfa)",
              color: "#fff",
              border: "none",
              borderRadius: 8,
              padding: "0.75rem 2rem",
              fontSize: "1rem",
              cursor: "pointer"
            }}
          >
            Refresh Page
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
